export default {
    when() {
        return document.querySelectorAll('.text-up-transition').length > 0;
    },

    mounted() {
        if (window.screen.width >= 1280) {
            let allTextUp = document.querySelectorAll('.text-up-transition');
            allTextUp.forEach((textUp) => {
                textUp.parentElement.style.transform =
                    'translateY(' + (textUp.clientHeight + 10) + 'px)';
            });
            let allCards = document.querySelectorAll('.text-up-card');
            allCards.forEach((card) => {
                card.addEventListener('mouseenter', () => {
                    console.log('card', card.parentElement);
                    card.parentElement
                        .querySelector('.card-image')
                        .classList.add('animate-zoom');
                    card.parentElement
                        .querySelector('.card-image')
                        .classList.remove('animate-zoom-reverse');
                    let text = card.querySelector('.text-up-transition');
                    text.parentElement.style.transform = 'translateY(0px)';
                    card.parentElement
                        .querySelector('.text-up-icon')
                        .classList.remove('hidden');
                    card.parentElement
                        .querySelector('.text-up-icon')
                        .classList.add('flex');
                    card.classList.add('bg-card');
                });
                card.addEventListener('mouseleave', () => {
                    card.parentElement
                        .querySelector('.card-image')
                        .classList.remove('animate-zoom');
                    card.parentElement
                        .querySelector('.card-image')
                        .classList.add('animate-zoom-reverse');
                    let text = card.querySelector('.text-up-transition');
                    text.parentElement.style.transform =
                        'translateY(' + (text.clientHeight + 10) + 'px)';
                    card.parentElement
                        .querySelector('.text-up-icon')
                        .classList.add('hidden');
                    card.parentElement
                        .querySelector('.text-up-icon')
                        .classList.remove('flex');
                    card.classList.remove('bg-card');
                });
            });
        }
    },
};
